import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setAddFile, setErrorsFile} from "features/model/slice/lessons/response-add-file/responseAddFile";


export const addFile = createAsyncThunk(
    'test/addFile',
    async ({ file, testId, questionId }: { file: File[], testId: number | string | undefined, questionId: string | number }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);

            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const { token } = JSON.parse(authToken);
            const formData = new FormData();

            file.forEach((file) => {
                formData.append(`file`, file);
            });

            formData.append('questionId', questionId.toString());

            const response = await axios.post(
                `/api/tests/file/${testId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(setAddFile(response.data));
            } else {
                thunkAPI.dispatch(setErrorsFile(response.data));
            }

            return response.data;
        } catch (error) {
            console.error('Произошла ошибка:', error);
            throw error;
        }
    }
);


